


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { SelectionPanelOption } from '../SelectionPanel/SelectionPanel.models';
import ResponsiveImage from '../utils/ResponsiveImage/index.vue';

@Component({
  components: {
    ResponsiveImage
  }
})
export default class GridSelect extends Vue {
  @Prop() private options!: SelectionPanelOption[];

  @Emit()
  private selectOption(option: SelectionPanelOption) {
    return option;
  }

  private toMediaContainer(option: SelectionPanelOption) {
    return {
      MQ1: option.thumbnail,
      MQ2: option.thumbnail,
      MQ3: option.thumbnail,
      MQ4: option.thumbnail,
      MQ5: option.thumbnail,
      MQ6: option.thumbnail
    };
  }
}
